export const mockedTravelInsuranceResponse = {
  insurance: [
    {
      search_product_result_id: '54cb47d0-6de6-433a-96b2-e7fef0ec1b3b',
      product_code: 'travel_insurance',
      inventory_provider: 'battleface',
      inventory_id: '12345-456789',
      removedFromCart: false,
      cart_item_id: undefined,
      inventory_item: {
        images: [
          {
            src: '/travel-insurance.jpg',
            description: 'Travel insurance',
          },
        ],
        visiting_duration: null,
        upgrade: null,
        accreditations: [],
        baggage_type: null,
        meal_type: null,
        description: '<p>battleface originally launched in the UK and Europe for adventure travelers seeking travel insurance and assistance services in unique destinations. As more travelers became aware of battleface, we evolved alongside them to provide policies to fit their specific needs.</p><p>Our service oriented approach and “travel insurance shouldn’t be a battle” resonated in the UK and Europe and quickly grew across the world to the United States, Australia, and Canada. </p><p>battleface was built different from the start and continues to innovate and offer a new approach to travel medical insurance and assistance services. Because battleface is more than just insurance; we make your safety our priority as you experience the world.</p>',
        overview: '<ul><li>- Global product availability based on country of residence</li><li>- 24/7 travel assistance and claims powered by Robin Assist</li><li>- Customer care rating (94%)</li><li>- Quick, fully digital claims experience</li></ul>',
        provider: 'Battleface originally launched in the UK and Europe for adventure travelers seeking travel insurance and assistance services in unique destinations. As more travelers became aware of battleface, we evolved alongside them to provide policies to fit their specific needs.<br><br>Our service oriented approach and “travel insurance shouldn’t be a battle” resonated in the UK and Europe and quickly grew across the world to the United States, Australia, and Canada. <br><br>battleface was built different from the start and continues to innovate and offer a new approach to travel medical insurance and assistance services. Because battleface is more than just insurance; we make your safety our priority as you experience the world. Battleface originally launched in the UK and Europe for adventure travelers seeking travel insurance and assistance services in unique destinations. As more travelers became aware of battleface, we evolved alongside them to provide policies to fit their specific needs.<br><br>',
        additional_fields: {
          full_address: {
            is_required: true,
            is_show: true
          },
          travellers: {
            is_required: true,
            is_show: true
          },
          zipcode: {
            is_required: false,
            is_show: true,
          },
          inbound_flight_number: {
            is_required: false,
            is_show: true,
          },
          phone_number: {
            is_required: false,
            is_show: true,
          },
          plate_number: {
            is_required: false,
            is_show: true,
          },
          outbound_flight_number: {
            is_required: false,
            is_show: true,
          },
        },
        product_option: {
          name: 'Travel Insurance',
          code: 'travel_insurance',
        },
        entrance_info: "",
        product_logo: {
          src: null,
        },
        capacity: {
          left: 500,
          message_threshold: null,
        },
        entry_date: '2026-06-01',
        features: [
          "Global product availability based on country of residence",
          "24/7 travel assistance services and claims powered by Robin Assist",
          "World-class customer care experience rated 94% by global customers",
          "Quick and efficient, fully digital claims experience"
        ],
        name: 'Travel Insurance Product',
        visiting_duration_message: null,
        logo: {
          src: 'https://branding.battleface.com/wp-content/uploads/2024/09/Battleface-Logo-Black.svg',
          description: 'logo',
        },
        exit_date: '2026-06-08',
        pii_questions: {
          order_management: null,
          payment: null,
        },
        is_featured: false,
        direction: null,
      },
      details: {
        visiting_duration: null,
        baggage_type: null,
        meal_type: null,
        visiting_duration_message: null,
        exit_date: '2026-06-08',
        airline_name: null,
        entry_date: '2026-06-01',
        direction: null,
      },
      inventory_options: [
        {
          fees: [],
          meta: null,
          cancellation_policies: [
            {
              title: 'Cancellation Policy',
              message: 'In the event of a cancellation, no refund will be given.',
            },
          ],
          taxes: [],
          amendment_policies: [
            {
              title: 'Amendment Policy',
              message: 'This booking cannot be amended.',
            },
          ],
          details: {
            duration: 60,
            groups: {
              senior: {
                is_selected: false,
              },
              adult: {
                age: {
                  min: 16,
                },
                is_selected: true,
                totals: {
                  single_total: 23.19,
                  subtotal: 23.19,
                  quantity: 1,
                },
              },
              infant: {
                is_selected: false,
              },
              child: {
                age: {
                  max: 16,
                  min: 0,
                },
                is_selected: false,
              },
            },
            cancellation_protection: {
              is_available: false,
            },
            is_parent: true,
          },
          sub_options: [
            {
              fees: [],
              meta: null,
              taxes: [],
              details: {
                name: "Business Cover",
                name_formatted: "Business Cover"
              },
              id: 123456789,
              totals: {
                fees: 0,
                total: 5,
                quantity: 1,
                subtotal: 5,
                taxes: 0,
                currency: "GBP",
                exchange: null
              },
              is_available: true
            },
            {
              fees: [],
              meta: null,
              taxes: [],
              details: {
                name: "Winter Sports Extension",
                name_formatted: "Winter Sports Extension"
              },
              id: 234567890,
              totals: {
                fees: 0,
                total: 11,
                quantity: 1,
                subtotal: 11,
                taxes: 0,
                currency: "GBP",
                exchange: null
              },
              is_available: true
            },
            {
              fees: [],
              meta: null,
              taxes: [],
              details: {
                name: "Sports and Activites",
                name_formatted: "Sports and Activites"
              },
              id: 345678901,
              totals: {
                fees: 0,
                total: 5,
                quantity: 1,
                subtotal: 5,
                taxes: 0,
                currency: "GBP",
                exchange: null
              },
              is_available: true
            }
          ],
          id: 111222333,
          totals: {
            fees: 0,
            total: 27.83,
            quantity: 1,
            subtotal: 23.19,
            bundle_saving: 0,
            discount: 0,
            taxes: 4.64,
            currency: 'GBP',
            exchange: null,
            channel_based: {
              total: 23.19,
              total_discounted: 23.19,
            },
          },
          is_available: true,
        },
      ],
    },
  ],
};
